import React, {Component} from 'react';
import PrintPreview from '../PrintPreview'
import HrStore from 'stores/HrStore'
import { momentHelper } from '../../report/helpers'
import './Print.css'

const DEFAULT_ROW = 41
class PrintReportSummaryNormalAbsence extends Component {

    constructor(...args) {
      super(...args)
        
      this.state = {loading:false,dataList:[],data:[],report_title:'กำลังดึงข้อมูล..'}

      var cssPagedMedia = (function() {
        var style = document.createElement('style');
        document.head.appendChild(style);
        return function (rule) {
          style.innerHTML = rule;
        };
      }());
  
      cssPagedMedia.size = function(size) {
        cssPagedMedia('@page {size: ' + size + '}');
      };
      cssPagedMedia.size('portrait');
    }

    componentDidMount() {
        this.loadData()
    }

    loadData() {
        if (this.props.year!=undefined&&this.props.month) {
            HrStore.loadReportAbsence(this.props.year-543,this.props.month,(result)=>{
                this.setState({data:result.data,dataList:this.getPagination(result.data),report_title:'ไม่พบข้อมูล'})
            },()=>{
                this.setState({data:[],dataList:this.getPagination([]),report_title:'ไม่พบข้อมูล'})
            })   
        } else {
            this.setState({data:[],dataList:this.getPagination([]),report_title:'ไม่พบข้อมูล'})
        }
    }

    getNumberFormat(value,digit=2) {
        let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
        _val = parseFloat(_val)
        return _val.toFixed(digit).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
    }
    
    getSummary(field) {
        let {data} = this.state
        let total = 0
        data.forEach((item,index)=> {
          let value = item[field].replace(' วัน','')
          total += (value===''||value===null||value===undefined||isNaN(value)?0:value*1)
        }) 
        return total
    }

    getPagination(data) {
        let newData = []
        let allData = []
        let checkRow = 0
        data.forEach(function(item,index) {
            if (checkRow<DEFAULT_ROW)
              checkRow++
              newData.push(item)
    
            if (checkRow===DEFAULT_ROW-1||index===data.length-1) {
              allData.push(newData)
              checkRow = 0
              newData = []
            }
        })  
        
        return allData
    }

    renderRowData(data,indexs) {
        if (data.length==0) {
          return(<tr><td colSpan={7}>ไม่พบข้อมูล</td></tr>)
        } else {
          return data.map((item, index) => (
            <tr key={index}>
                <td className='text-center'>{(indexs*40)+index+1}</td>
                <td className='text-center'>{item.employee_id}</td>
    			<td className='text-center'>{item.name}</td>
    			<td className='text-center'>{item.nick_name}</td>
    		    <td className='text-center'>{item.position}</td>
    			<td className='text-center'>{item.department}</td>
    			<td className='text-center'>{item.absence_text}</td>
            </tr>
          ))
        }
    }

    renderTable(item,index,length) {
        return(
            <table className='table table-print-report-hr'>
                <tbody>
                    <tr>
                        <td className='text-center' style={{width:'50px'}}>ลำดับ</td>
                        <td className='text-center' style={{width:'120px'}}>รหัสพนักงาน</td>
                        <td className='text-center' style={{width:'200px'}}>ชื่อ-นามสกุล</td>
                        <td className='text-center' style={{width:'100px'}}>ชื่อเล่น</td>
                        <td className='text-center' style={{width:'100px'}}>ตำแหน่ง</td>
                        <td className='text-center' style={{width:'100px'}}>แผนก</td>
                        <td className='text-center' style={{width:'90px'}}>จำนวนวัน</td>
                    </tr>
                    {this.renderRowData(item,index)}
                    {length-1===index?
                    <tr>
                        <td colSpan={6} className='text-right'>ยอดรวมสุทธิ</td>
                        <td className='text-center'>{this.getSummary('absence_text')} วัน</td>
                    </tr>
                    :''}
                </tbody>
            </table>
        )
    }

    renderComponentPage(item,index,length) {
        return(  
            <div className='font-print' key={index}>
                <header className="text-center">
                    <h2>{this.props.title}</h2>
                </header>
                {this.props.month!=undefined&&this.props.year!=undefined?
                <div>
                    ประจำ {this.props.month==0||this.props.month=='0'?'ปี '+this.props.year:'เดือน '+momentHelper.getMonthText(this.props.month)+' ปี '+this.props.year}
                </div>
                :''
                }
                <div>
                    {this.renderTable(item,index,length)}
                </div>
            </div>
        )    
    }
    
    renderNoData() {
        return(
          <div className='font-print'>
            <header className="text-center">
              <h2>{this.state.report_title}</h2>
            </header>
          </div>
        )
    }

    render() {
        let {loading,dataList} = this.state
        if (dataList.length==0) {
            return(
                <PrintPreview 
                    loading={loading}
                    leftBarTitle={this.props.title}
                >
                    {this.renderNoData()}    
                </PrintPreview>
            )
        } else {
            return(
                <PrintPreview 
                    loading={loading}
                    leftBarTitle={this.props.title}
                >
                    {
                        dataList.map((item,index)=>{
                            return(
                                this.renderComponentPage(item,index,dataList.length)
                            )
                        })   
                    }
                </PrintPreview>
            )
        }      
    }
}

PrintReportSummaryNormalAbsence.defaultProps = {
    title: 'ตารางรายงานลางานทั่วไป',  
    mode: '',
    workNo: ''
  }
  export default PrintReportSummaryNormalAbsence;


// WEBPACK FOOTER //
// ./src/view/print/hr/PrintReportSummaryNormalAbsence.js